import React from "react";

/*
    Notifications Icon
    props:
        - title: string, override the default title 'Overview'
        - color: string, override the default color '#00549A' (bell blue)
*/

const HomeIcon = (props) => (
    <svg className={props.className} width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Overview"}</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.116 9.03043C1.79059 9.03043 1.62762 8.6523 1.8577 8.43114L9.7417 0.85284C9.88435 0.71572 10.1157 0.71572 10.2583 0.85284L18.1423 8.43114C18.3724 8.6523 18.2094 9.03043 17.884 9.03043H15.9403V16.8989C15.9403 17.0928 15.7767 17.25 15.575 17.25H4.425C4.22327 17.25 4.05973 17.0928 4.05973 16.8989V9.03043H2.116Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default HomeIcon;
